<template>
    <LargeModal
        :show="show"
        title="Leave a review"
        subtitle="Add a review for this guide"
        @close="$emit('close')"
    >
        <div class="space-y-6 sm:space-y-5">
            <div class="flex justify-between">
                <div v-if="guide !== null" class="flex items-center">
                    <div class="h-10 w-10 flex-shrink-0">
                        <img
                            class="h-10 w-10 rounded-full object-cover"
                            :src="guide.user.profile_photo_url"
                            :alt="guide.user.name"
                        >
                    </div>
                    <div class="ml-4">
                        <div class="font-medium text-gray-900">
                            {{ guide.user.name }}
                        </div>
                        <div class="text-gray-500">
                            {{ guide.team.name }}
                        </div>
                    </div>
                </div>
                <span class="text-sm text-gray-600 m-auto">in</span>
                <div class="flex items-center">
                    <div class="mr-4 text-right">
                        <div class="font-medium text-gray-900">
                            {{ engagement.place.name }}
                        </div>
                        <div class="text-gray-500">
                            {{ engagement.place.area }}
                        </div>
                    </div>
                    <div class="h-10 w-10 flex-shrink-0">
                        <img
                            class="h-10 w-10 rounded-full object-cover"
                            :src="engagement.place.image"
                            :alt="engagement.place.name"
                        >
                    </div>
                </div>
            </div>

            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Comment </label>
                <div class="mt-1 sm:mt-0 sm:col-span-2">
          <textarea
              v-model="form.comment"
              :class="{'border-red-300': form.errors.comment }"
              class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
          />
                    <p
                        v-if="form.errors.comment"
                        class="mt-2 text-sm text-red-600"
                    >
                        {{ form.errors.comment }}
                    </p>
                </div>
            </div>

            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Rating </label>
                <star-rating v-model:rating="form.rating"></star-rating>
            </div>

        </div>

        <template #footer>
            <CreateButton
                class="m-2"
                @click="save"
            >Leave review</CreateButton>
            <CancelButton
                class="m-2"
                @click="close"
            />
        </template>
    </LargeModal>
</template>

<script>

import LargeModal from '@/ComponentsDeprecated/Modal/LargeModal.vue';
import CancelButton from '@/ComponentsDeprecated/Buttons/CancelButton';
import CreateButton from '@/ComponentsDeprecated/Buttons/CreateButton';
import '@vuepic/vue-datepicker/dist/main.css';
import StarRating from 'vue-star-rating'

export default {
    components: {
        LargeModal,
        CancelButton,
        CreateButton,
        StarRating
    },
    props: [
        'show',
        'engagement',
        'guide'
    ],
    data() {
        return {
            form: this.$inertia.form({
                guide_profile_id: null,
                engagement_id: null,
                comment: '',
                rating: null
            }),
        };
    },
    watch: {
        show: function(newVal, oldVal) {
            if (newVal && typeof this.guide.reviews[0] !== 'undefined') {
                this.form.comment = this.guide.reviews[0].comment;
                this.form.rating = this.guide.reviews[0].rating;
            }
        }
    },
    methods: {
        save() {
            this.form.guide_profile_id = this.guide.id;
            this.form.post(route('engagement.guide_review', {engagement: this.engagement.id}), {
                errorBag: 'storeOffer',
                preserveScroll: true,
                onSuccess: () => {
                    this.form.reset();
                    this.$emit('close');
                },
            });
        },
        close() {
            this.$emit('close');
            this.form.reset();
        },
    },

};
</script>
